module.exports = __webpack_public_path__ + "img/centrifugacion.8424db03.png";